import React from "react";
import Button from "../../../../../components/ui/Button/Button";
import { Dropdown } from "../../../../../components/ui/Dropdown/Dropdown";
import InputSearch from "../../../../../components/ui/InputSearch/InputSearch";
import InputDate from "../../../../../components/ui/InputDate/InputDate";

const registrationStatus = [
  { id: "", name: "전체" },
  { id: "NORMAL", name: "정상 등록" },
  { id: "REPORT", name: "신고 상태" },
  { id: "HIDDEN", name: "숨김 상태" },
];

const searchOptions = [
  { id: "productGroupName", name: "관련 상품명" },
  { id: "contents", name: "내용" },
];

const ReviewFilter = (props) => {
  const {
    onFilter,
    onSubmitFilter,
    onResetFilter,
    onChangeSearchByValue,
    filter,
    onChangeSearchBy,
  } = props;
  return (
    <div className="-mt-4 flex justify-between bg-input-grey">
      <div className="space-y-3 py-4 pl-6">
        <div className="flex text-[11px] space-x-4 items-center">
          <h1 className="font-bold text-[12px] w-14">등록 상태</h1>
          {registrationStatus.map((item, index) => (
            <div key={item.id} className="flex items-center">
              <input
                id={`item_${index}`}
                name="status"
                type="radio"
                className="accent-black mr-2"
                value={item?.id}
                onChange={(event) =>
                  onFilter({ ...filter, status: event.target.value })
                }
              />
              <label htmlFor={`item_${index}`}>{item.name}</label>
            </div>
          ))}
        </div>

        <div className="flex text-[11px] space-x-4 items-center">
          <div className="flex items-center space-x-4">
            <h1 className="font-bold text-[12px] w-14">검색어</h1>
            <Dropdown
              options={searchOptions}
              placeholder={`관련 상품명`}
              backgroundDropdown={`bg-white`}
              textColor="text-black"
              width="w-36"
              positionDropdown={`top-10`}
              onClickItem={onChangeSearchBy}
            />
            <InputSearch
              onChange={(value) => onChangeSearchByValue(value)}
              placeholder={`검색`}
              isMagnifyingGlass={false}
            />
          </div>
          <div className="flex items-center">
            <h1 className="font-bold text-[12px] mr-5 ml-4">기간</h1>
            <InputDate
              onChange={(value) =>
                onFilter({ ...filter, from: value?.startOf("day").valueOf() })
              }
            />
            <span className="mx-2 text-secondary-grey">-</span>
            <InputDate
              onChange={(value) =>
                onFilter({ ...filter, to: value?.endOf("day").valueOf() })
              }
            />
          </div>
        </div>
      </div>
      <div className="py-4 mr-1">
        <Button
          onClick={onSubmitFilter}
          text={`필터 검색`}
          width="w-28"
          borderColor="border-secondary-grey border"
          textColor="black"
          paddingButton="py-1"
        />
        <Button
          onClick={onResetFilter}
          text={`필터 초기화`}
          width="w-28"
          borderColor="border-secondary-grey border"
          textColor="black"
          paddingButton="py-1"
        />
      </div>
    </div>
  );
};

export default ReviewFilter;
